module.exports = {
          srcSet: __webpack_public_path__ + "93ca7122.jpg"+" 700w"+","+__webpack_public_path__ + "2655a362.jpg"+" 1400w"+","+__webpack_public_path__ + "15b58a54.jpg"+" 1620w",
          images:[ {path: __webpack_public_path__ + "93ca7122.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "2655a362.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "15b58a54.jpg",width: 1620,height: 1080}],
          src: __webpack_public_path__ + "93ca7122.jpg",
          toString:function(){return __webpack_public_path__ + "93ca7122.jpg"},
          
          width: 700,
          height: 467
        }